const Table = () => import('@/../../coreui/components/ServerTable')
const Reports = () => import('@/components/cultivation/ReportsGenerator')
export default function buildMenu (allowed) {
  if (allowed == null || allowed.includes('Cultivation'))  {
    return [
      {
        name: 'culProducts', 
        path: '/culProducts', 
        component: Table, 
        props: {schema: 'sch_fac_products', table: 'fac_products'}
      },
      {
        name: 'culBins', 
        path: '/culBins', 
        component: Table, 
        props: {schema: 'sch_cul_bin', table: 'cul_bin'}
      },
      {
        name: 'culMoms', 
        path: '/culMoms', 
        component: Table, 
        props: {schema: 'sch_cul_mother', table: 'cul_mother'}
      },
      {
        name: 'culClones', 
        path: '/culClones', 
        component: Table, 
        props: {schema: 'sch_cul_clone', table: 'cul_clone'}
      },
      {
        name: 'culPlantings', 
        path: '/culPlantings', 
        component: Table, 
        props: {schema: 'sch_cul_plantings', table: 'cul_plantings'}
      },
      {
        name: 'culPlants', 
        path: '/culPlants', 
        component: Table, 
        props: {schema: 'sch_cul_plants', table: 'cul_plants'}
      },
      {
        name: 'culHarvest', 
        path: '/culHarvest', 
        component: Table, 
        props: {schema: 'sch_cul_harvest', table: 'cul_harvest'}
      },
      {
        name: 'culProcess', 
        path: '/culProcess', 
        component: Table, 
        props: {schema: 'sch_cul_process', table: 'cul_process'}
      },
      {
        name: 'culTrim', 
        path: '/culTrim', 
        component: Table, 
        props: {schema: 'sch_cul_trim', table: 'cul_trim'}
      },
      {
        name: 'culInventory', 
        path: '/culInventory', 
        component: Table, 
        props: {schema: 'sch_fac_inventory', table: 'fac_inventory'}
      },
      {
        name: 'culReports', 
        path: '/culReports', 
        component: Reports
      },
      {
        name: 'culWaste',
        path: '/culWaste',
        component: Table,
        props: {schema: 'sch_cul_waste', table: 'cul_waste'}
      }
  ] } else return []
}
